<template>
  <jw-modal v-model:visible="showWEditor" title-align="start" width="60%" :on-before-ok="beforeOk" @ok="handelOk" @cancel="handleCancel" :mask-closable="false">
    <template #title>富文本编辑</template>
    <w-editor ref="inputRef" v-model="fieldValue" :configs="{ height: 500 }"></w-editor>
  </jw-modal>
</template>
<script setup>
import { ref, watch } from 'vue';
import { tools } from '@/utils/tools.js';
import { Message } from '@arco-design/web-vue';
import { useI18n } from 'vue-i18n';
const props = defineProps({
  modelValue: String,
  isRequired: Boolean
});
const emits = defineEmits(['cb', 'change']);
const showWEditor = ref(false);
const fieldValue = ref(props.modelValue);
const inputRef = ref(null);
const { t } = useI18n();
watch(
  () => fieldValue.value,
  (newVal) => {
    emits('change', newVal);
  }
);
const isNoText = (textValue) => {
  if (!textValue || (!tools.handleRichText(textValue) && props.isRequired)) return true;
  return false;
};

const beforeOk = () => {
  if (inputRef.value.isAiFormatting()) {
    Message.error(t('AI排版中...'));
    return false;
  }
  // 富文本空值处理
  if (fieldValue.value === '<p><br></p>') {
    fieldValue.value = '';
  }
  if (isNoText(fieldValue.value)) {
    //必填校验
    Message.warning('必填字段不能为空!');
    return false;
  }
  return true;
};

const handelOk = () => {
  emits('cb', { type: 'ok', value: fieldValue.value });
};

const handleCancel = () => {
  showWEditor.value = false;
  emits('cb', { type: 'cancel' });
};

const openDialog = (record) => {
  fieldValue.value = record.fieldValue;
  showWEditor.value = true;
};
defineExpose({
  openDialog
});
</script>
